export default __webpack_public_path__ + "static/media/amount-token.35ebb365.svg";